import { render, staticRenderFns } from "./CreateAReport.vue?vue&type=template&id=08cf529a"
import script from "./CreateAReport.vue?vue&type=script&lang=js"
export * from "./CreateAReport.vue?vue&type=script&lang=js"
import style0 from "./CreateAReport.vue?vue&type=style&index=0&id=08cf529a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports